<div class="container">
    <ng-container *ngIf="isReadMode; else writeMode">
    <span>{{ value ?? 0 | multilingualCurrency }}</span>
    </ng-container>
    <ng-template #writeMode>
        <div class="write-mode-container">
            <mat-form-field appearance="outline">
            <input matInput type="text" 
            mask="separator.2" 
            [thousandSeparator]="thousandSeparator"
            [decimalMarker]="decimalMarker"
            [prefix]="currencyPrefix"
            [suffix]="currencySuffix" 
            [leadZeroDateTime]="true"
            [placeHolderCharacter]="'0'"
            [inputTransformFn]="restrictCurrencyInput"
            [attr.max]="max"
            [ngModel]="value"
            (ngModelChange)="onValueChange($event)"
            (blur)="onBlur()"
            [disabled]="isDisabled"/>
            </mat-form-field>
        </div>
    </ng-template>
</div>
 
 
 